<template>
    <div class="container content-page-wrapper users-index" :class="{'loading': loading}">
        <div class="row py-5">
            <div class="col-12 m-auto p-0">
                <h1 class="mb-3 float-left">{{ $t('User list') }}</h1>
                <div class="text-right mb-3 float-right">
                    <form class="form-inline my-2 my-lg-0" v-if="users">
                        <input class="form-control mr-sm-2 ml-sm-auto" type="search" :placeholder="$t('Name')" :aria-label="$t('Search')" v-model="search_string">
                        <button class="btn btn-outline-primary my-2 my-sm-0" type="submit" @click.prevent="getUsers">{{ $t('Search') }}</button>
                    </form>
                </div>
                <div v-if="users.data && users.meta.total > 0">
                    <table class="table table-light">
                    <thead class="thead-dark">
                        <tr>
                            <th class="lead">{{ $t('Company') }}</th>
                            <th class="lead d-none d-sm-table-cell">{{ $t('Contact person') }}</th>
                            <th class="lead d-none d-sm-table-cell">{{ $t('Contact') }}</th>
                            <th class="lead">{{ $t('Status') }}</th>
                            <th class="text-right lead d-none d-sm-table-cell">{{ $t('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="userData in users.data">
                            <td><router-link class="font-weight-bold" tag="a" :to="{ name: 'users.show', params: { id: userData.id } }" v-if="userData.id">{{ userData.name }}</router-link></td>
                            <td class="d-none d-sm-table-cell">{{ userData.first_name }} {{ userData.last_name }}</td>
                            <td class="d-none d-sm-table-cell">{{ userData.email ?  $t('E-mail') + ': ' + userData.email : '' }}<br>{{ userData.phone ? $t('Phone') + ': ' + userData.phone : '' }}</td>
                            <td>
                                <span class="btn btn-sm btn-light" v-if="userData.roles.indexOf('Customer') !== -1">{{ $t('Customer') }}</span>
                                <span class="btn btn-sm btn-success" v-if="userData.roles.indexOf('Authorized Customer') !== -1">{{ $t('Authorized customer') }}</span>
                                <span class="btn btn-sm btn-primary" v-if="userData.roles.indexOf('Employee') !== -1">{{ $t('Employee') }}</span>
                                <span class="btn btn-sm btn-primary" v-if="userData.roles.indexOf('Employeeadmin') !== -1">{{ $t('Employee admin') }}</span>
                                <span class="btn btn-sm btn-primary" v-if="userData.roles.indexOf('Superadmin') !== -1">{{ $t('Admin') }}</span>
                                <span class="small" v-if="userData.last_login_at"><br>{{ $t('Last login') }}: {{ userData.last_login_at }}</span>
                            </td>
                            <td class="text-right d-none d-sm-table-cell">
                                <router-link class="btn btn-sm btn-primary text-white" tag="a" :to="{ name: 'users.show', params: { id: userData.id } }"><i class="far fa-eye" :title="$t('Open')"></i></router-link>
                                <div class="dropdown d-inline-block">
                                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" :id="'user-edit-button-' + userData.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!$can('edit_users')">
                                        <i class="far fa-edit"></i>
                                    </button>
                                    <div class="dropdown-menu" :aria-labelledby="'user-edit-button-' + userData.id">
                                        <router-link class="dropdown-item" tag="a" :to="{ name: 'users.show', params: { id: userData.id } }" v-if="$can('edit_users')">Bearbeiten</router-link>
                                        <a href="#" class="dropdown-item" @click="authorizeCustomer(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles.indexOf('Customer') !== -1">{{ $t('Authorize customer') }}</a>
                                        <a href="#" class="dropdown-item" @click="revokeCustomerAuthorization(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles.indexOf('Authorized Customer') !== -1">{{ $t('Remove authorization') }}</a>
                                        <a href="#" class="dropdown-item" @click="authorizeEmployee(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && ( userData.roles.indexOf('Customer') !== -1 || userData.roles.indexOf('Authorized Customer') !== -1)">{{ $t('Employee authorization') }}</a>
                                        <a href="#" class="dropdown-item" @click="revokeEmployeeAuthorization(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles.indexOf('Employee') !== -1">{{ $t('Remove employee authorization') }}</a>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-danger" @click.prevent="deleteUser(userData.id)" :disabled="userDeleting" v-if="($can('authenticate_customers') && userData.roles && userData.roles.indexOf('Superadmin') === -1 && userData.roles.indexOf('Employeeadmin') === -1) || (user.roles && user.roles.indexOf('Superadmin') !== -1)"><i class="far fa-trash-alt" title="Löschen"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                    <pagination :data="users" @pagination-change-page="getUsers"></pagination>
                </div>
                <p class="text-white" v-else>{{ $t('No registered users found') }}</p>

            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {

    data() {
        return {
            product_configurator_id: 1,
            loading: false,
            users: {},
            userDeleting: false,
            customerAuthorizing: false,
            search_string: '',
        };
    },

    mounted() {
        this.getUsers();
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),

    },

    methods: {

		getUsers(page = 1) {
		    this.loading = true;
			axios.get('/api/users?page=' + page + '&paginate=20' + (this.search_string ? '&search_string=' + this.search_string : ''))
				.then(response => {
					this.users = response.data;
					this.loading = false;
				}).catch(error => {
                this.loading = false;
            });
        },

        authorizeCustomer(user_id) {
            this.$swal.fire({
                title: 'Kunde autorisieren?',
                text: "Wenn Sie diesen Kunden autorisieren, kann dieser Preise einsehen.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, autorisieren!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/authorize_customer')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich autorisiert'
                            });
                            this.getUsers();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        revokeCustomerAuthorization(user_id) {
            this.$swal.fire({
                title: 'Autorisierung entziehen?',
                text: "Wenn Sie diesen Kunden die Authorisierung entziehen, kann dieser keine Preise mehr einsehen.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, entziehen!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/revoke_customer_authorization')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Authorisierung erfolgreich entzogen'
                            });
                            this.getUsers();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        authorizeEmployee(user_id) {
            this.$swal.fire({
                title: 'Account in Mitarbeiter umwandeln?',
                text: "Durch diese Aktion erhält der User zahlreiche weitere Rechte.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, autorisieren!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;
                    this.loading = true;

                    axios.put('/api/users/' + user_id + '/authorize_employee')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich autorisiert'
                            });
                            this.getUsers();
                            this.customerAuthorizing = false;
                            this.loading = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                        this.loading = false;
                    });

                }
            })
        },

        revokeEmployeeAuthorization(user_id) {
            this.$swal.fire({
                title: 'In Kundenaccount umwandeln?',
                text: "Wenn Sie diesen Mitarbeiter die Authorisierung entziehen, verliert dieser zahlreiche Rechte.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, umwandeln!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/revoke_employee_authorization')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Authorisierung erfolgreich entzogen'
                            });
                            this.getUsers();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        deleteUser(user_id) {
            this.$swal.fire({
                title: 'Benutzer löschen?',
                text: "Nach dem Löschen kann der Account und die zugehörigen Projekte nicht wiederhergestellt werden.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e3342f',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, löschen!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.userDeleting = true;
                    this.loading = true;
                    axios.delete('/api/users/' + user_id)
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich gelöscht'
                            });
                            this.getUsers();
                            this.userDeleting = false;
                            this.loading = false;
                        }).catch(error => {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten'
                        });
                        this.userDeleting = false;
                        this.loading = false;
                    });

                }
            })
        },



	},
};
</script>
